<template>
  <div class="app-container">
    <el-form v-model="queryForm" :inline="true" class="query-form">
      <el-form-item>
        <el-input v-model="queryForm.title" clearable type="text" placeholder="请输入标题查询" />
      </el-form-item>
      <el-button type="primary" @click="handleSearch">
        <i class="el-icon-search" />查询
      </el-button>
      <el-button type="default" @click="resetSearch">
        <i class="el-icon-refresh" />重置刷新
      </el-button>
    </el-form>
    <el-divider class="query-form-divider" />
    <div class="query-button-wrap">
      <el-button type="success" @click="handleCreateNew" class="margin-bottom-20">
        <i class="el-icon-plus" />新建
      </el-button>
      <el-button type="primary" @click="back">返回</el-button>
    </div>

    <el-table v-loading="table.listLoading" :data="table.items" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort">
      <!-- <el-table-column label="id" width="80" prop="id" sortable></el-table-column> -->
      <el-table-column label="标题" prop="title"></el-table-column>
      <el-table-column label="排序" prop="order" sortable></el-table-column>
      <el-table-column label="答案选项">
        <template slot-scope="scope">
          <div v-for="(item,index) in scope.row.topicContent" :key="index">
            {{item.key}} : {{item.content}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page.sync="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.pagesize" layout="total,jumper,prev, pager, next,sizes" :total="table.totalCount" @size-change="handleSizeChange" @current-change="current_change" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="form.show" :close-on-click-modal="false">
      <el-form ref="dataForm" :rules="form.rules" :model="form.data" style="height:400px;overflow-y: auto">
        <!-- <el-form-item v-if="questions.length" label="所属问卷" prop="questionId">
          <el-select v-model="form.data.questionId" clearable placeholder="请选择问卷">
            <el-option v-for="item in questions" :key="item.id" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item> -->

        <el-form-item label="标题" prop="title">
          <el-input v-model="form.data.title" />
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input v-model="form.data.order" />
        </el-form-item>

        <el-form-item prop="topicContent">
          <el-row>
            <label>答案选项</label>
            <el-button type="primary" @click="handleContentAdd" style="float:right">添加</el-button>
          </el-row>
          <el-row :gutter="20" v-for="(item, index) in form.data.topicContent" :key="index" style="margin-top:5px;margin-left:0;margin-right:0">
            <el-col :span="1">
              <label>{{item.key}}</label>
            </el-col>
            <el-col :span="20">
              <el-input v-model="item.content" />
            </el-col>
            <el-col :span="3" style="text-align: right;padding-right: 0px;">
              <el-button type="danger" @click="handleContentDelete(index)">删除</el-button>
            </el-col>
          </el-row>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="default" @click="form.show = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?handleSave():handleSave()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const defaultData = {
  id: 0,
  questionId: ""
};

const controller = "questionTopic";
var topicContentKeyMapping = [];

for (let index = 65; index < 91; index++) {
  topicContentKeyMapping.push(String.fromCharCode(index));
}

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    var checkTopicContent = (rule, value, callback) => {
      if (value.length < rule.minLength) {
        return callback(new Error(rule.message));
      } else {
        callback();
      }
    };

    return {
      questionId: this.$route.params.id,
      table: {
        items: [],
        listLoading: true,
        pagesize: 20,
        page: 1,
        totalCount: 0,
        sorting: "id desc"
      },
      dialogStatus: "",
      queryForm: {
        title: ""
      },
      form: {
        show: false,
        submitting: false,
        data: {
          ...defaultData
        },
        rules: {
          questionId: [
            {
              required: true,
              message: "请选择调查",
              trigger: "change"
            }
          ],
          title: [
            {
              required: true,
              message: "请输入题目标题",
              trigger: "blur"
            }
          ],
          order: [
            {
              required: true,
              message: "请输入题目排序",
              trigger: "blur"
            }
          ],
          topicContent: [
            {
              validator: checkTopicContent,
              minLength: 1,
              message: "至少要有一条选项"
            }
          ]
        },
        topicContentKeyMapping: topicContentKeyMapping
      },
      textMap: {
        update: "编辑",
        create: "新建"
      },
      questions: []
    };
  },
  created() {
    this.fetchData(); // 如果开启了默认排序,不需要这一行
  },
  methods: {
    fetchData() {
      this.table.listLoading = true;
      this.$abpApi[controller]
        .getAll({
          skipCount: (this.table.page - 1) * this.table.pagesize,
          questionId: this.questionId,
          sorting: this.table.sorting,
          maxResultCount: this.table.pagesize,
          title: this.queryForm.title
        })
        .then(response => {
          this.table.items = response.data.items;
          this.table.totalCount = response.data.totalCount;
          this.table.listLoading = false;
        });
    },
    // 切换切面,在watch中监听 page
    current_change(e) {
      this.table.page = e;
    },
    // 排序
    sort(e) {
      console.log("sort : ", e);
      if (e.prop && e.order) {
        this.table.sorting = `${e.prop} ${e.order}`;
      } else {
        this.table.sorting = "id descending";
      }
      this.fetchData(1);
    },
    handleSizeChange(e) {
      this.table.pagesize = e;
      this.fetchData();
    },
    handleSearch() {
      this.fetchData();
    },
    handleCreateNew() {
      this.resetForm();
      this.dialogStatus = "create";
      this.form.show = true;
      this.$abpApi[controller]
        .getForEdit({
          id: 0
        })
        .then(res => {
          this.form.data = res.data.data;
          this.questions = res.data.schema.questionId;
        });
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleEdit($index, $row) {
      this.resetForm();
      const { id } = $row;
      this.$abpApi[controller]
        .getForEdit({
          id
        })
        .then(res => {
          this.form.data = res.data.data;
          this.questions = res.data.schema.questionId;
          this.dialogStatus = "update";
          this.form.show = true;
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        });
    },
    handleSave() {
      this.form.data.questionId = this.questionId;
      this.$refs["dataForm"].validate((valid, obj) => {
        console.log(valid, obj);
        // console.log(this.form.data);
        if (valid) {
          let fn;
          if (this.form.data.id) {
            fn = this.$abpApi[controller].update;
          } else {
            fn = this.$abpApi[controller].create;
          }
          fn(this.form.data).then(res => {
            this.form.submitting = false;
            this.form.show = false;
            this.fetchData();
          });
        }
      });
    },
    handleDelete($index, $row) {
      const { id } = $row;
      this.$confirm("您确认要删除吗", "删除提示").then(() => {
        this.$abpApi[controller]
          .delete({
            id
          })
          .then(res => {
            console.log("delete then");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.fetchData();
          });
      });
    },
    resetForm() {
      this.form = Object.assign({}, this.form, {
        data: {
          ...defaultData
        }
      });
    },
    resetSearch() {
      this.queryForm = {
        title: ""
      };
      this.fetchData();
    },
    // 图片上传前判断
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 上传成功后回调
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.success) {
        //这里写回调逻辑
        // this.form.data.titleImagePath = res.result
      }
    },
    handleContentAdd() {
      this.form.data.topicContent.push({
        key: this.form.topicContentKeyMapping[
          this.form.data.topicContent.length
        ],
        content: `${
          this.form.topicContentKeyMapping[this.form.data.topicContent.length]
        }选项的内容`
      });
    },
    handleContentDelete(index) {
      this.form.data.topicContent.splice(index, 1);
      for (let index = 0; index < this.form.data.topicContent.length; index++) {
        this.form.data.topicContent[
          index
        ].key = this.form.topicContentKeyMapping[index];
      }
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
}

.avatar {
  width: 88px;
  height: 88px;
  display: block;
}
.el-dialog__body {
  height: 400px;
  overflow-y: auto;
}
</style>
